import type { ThemeDefinition } from './types';

export const playful: ThemeDefinition = {
  variables: {
    '--report-font-display': "system-ui, -apple-system, 'Segoe UI', sans-serif",
    '--report-font-body': "system-ui, -apple-system, 'Segoe UI', sans-serif",
    '--report-bg': '#fef9ec',
    '--report-bg-surface': '#fef3cd',
    '--report-text': '#1c1917',
    '--report-text-secondary': '#57534e',
    '--report-text-muted': '#a8a29e',
    '--report-accent': '#f59e0b',
    '--report-accent-dim': 'rgba(245, 158, 11, 0.12)',
    '--report-border': '#e7e5e4',
    '--report-border-strong': '#d6d3d1',
    '--report-stat-color': '#1c1917',
    '--report-stat-positive': '#16a34a',
    '--report-stat-negative': '#dc2626',
    '--report-callout-bg': '#fef3cd',
    '--report-callout-border': '#f59e0b',
    '--report-surface-hover': '#fde9a8',
    '--report-measure': '780px',
  },
};
